export function getCallenderDay(month: number, year: number) {
  let days = [],
    prevDays = [],
    nextDays = [];
  let currentMonthIndex = month;
  let date = new Date(year, currentMonthIndex, 1);

  while (date.getMonth() === currentMonthIndex) {
    days.push({
      day: date.getDate(),
      month: date.getMonth(),
      year: date.getFullYear(),
    });
    date.setDate(date.getDate() + 1); // Move to the next day
  }

  // get days of month for previous month
  const previousMonthLastDay = new Date(year, currentMonthIndex, 0);
  prevDays.push({
    day: previousMonthLastDay.getDate(),
    month: previousMonthLastDay.getMonth(),
    year: previousMonthLastDay.getFullYear(),
  });

  do {
    previousMonthLastDay.setDate(previousMonthLastDay.getDate() - 1);
    prevDays = [{
      day: previousMonthLastDay.getDate(),
      month: previousMonthLastDay.getMonth(),
      year: previousMonthLastDay.getFullYear(),
    }, ...prevDays];
  } while (previousMonthLastDay.getDay() !== 0);

  // get days of month for next month
  // get number of days remaning
  const remaningDays = 42 - days.length - prevDays.length; // 42 = (6 X 7), because we are using 6 row calender format, 7 = week days

  const nextMonthFirstDay = new Date(year, currentMonthIndex + 1, 1);
  for (let i = 0; i < remaningDays; i++) {
    nextDays.push({
      day: nextMonthFirstDay.getDate(),
      month: nextMonthFirstDay.getMonth(),
      year: nextMonthFirstDay.getFullYear(),
    });
    nextMonthFirstDay.setDate(nextMonthFirstDay.getDate() + 1);
  }

  return {
    current: days,
    prev: prevDays,
    next: nextDays,
  };
}
